import type { FaireProductEntity } from "../../entity_types/product";

export const p_ebmgq7grw4: FaireProductEntity = {
  token: "p_ebmgq7grw4",
  type: "product",
  name: "Life Starts At Fuck It Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/6f3894df03c1f4973ce03b14b82c5f3a9014d74460c4ccacda16cdbd35c9a285.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e45e44ff4e8707afaa83ae7ddf41dcf06eca00d5f2c8970bee9ce10b3b3eaec1.jpeg",
    "https://cdn.faire.com/fastly/edaacd5b0d836fb2c19453b3f0e42cfb1ebb35dcff9ba25abb2c7fd60b6b2804.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/3a93344485ce589a23070e66ac3bc8a0bad4949f4cbd9e6c83564a1183ede58c.jpeg",
    "https://cdn.faire.com/fastly/9d42bed0531a8395ae6e6b6b009d0c7fe8ce61969d76d02a34b1745508706588.jpeg"
  ],
  priceDollars: 3.38,
  description: "The socks you wear when inner peace looks a lot like both middle fingers pointed all the way up! 🖕🤠🖕 Rock bottom is the launch pad, and these socks are the rocket boosters. 🚀🧦\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:27.168Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
